import { Typography, Box } from '@mui/material';
import { useDirectorySearchContext } from '../contexts/DirectorySearchContext';
import ItemCollectionDisplay from './ItemCollectionDisplay';
import AutoCompleteCollection from './AutoCompleteCollection';
import { DisplayParams } from '../types/classes/DisplayParams';
import { DirectoryResource } from '../constants/DirectoryResource';
import ParseHTML from "../../global/components/ParseHTML";

/**
 * DirectorySearchAndDisplay Component
 * 
 * This component creates the holder for the member directory autocomplete filters and member directory results display.
 * It displays the autocomplete filters on the left and the display of a list of member items on the right.
 * 
 * Example usage:
 * ```tsx
 * <DirectorySearchAndDisplay />
 * ```
 * 
 * @returns {JSX.Element} The component displaying the autocomplete filters and directory results.
 */
export default function DirectorySearchAndDisplay() {

    const { isInitialState, displayParams, setDisplayParams } = useDirectorySearchContext();

    return (
        <>
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
                alignContent: 'flex-start',
                padding: 6
            }}>
                <Box sx={{ width: 272 }}>
                    <AutoCompleteCollection
                        displayParams={displayParams as DisplayParams}
                        onDisplayChange={setDisplayParams} />
                </Box>
                {isInitialState && (
                    <Box sx={{ display: 'flex', width: { xs: "100%", md: "70%", lg: "75%" } }}>
                        <Typography variant="body2">
                            {ParseHTML(DirectoryResource.instruction_text_hdr)}
                            <ul>
                                <li>{DirectoryResource.instruction_bullet_1}</li>
                                <li>{DirectoryResource.instruction_bullet_2}</li>
                                <li>{DirectoryResource.instruction_bullet_3}</li>
                                <li>{ParseHTML(DirectoryResource.instruction_bullet_4)}</li>
                            </ul>
                        </Typography>
                    </Box>)
                }
                {!isInitialState && (
                    <Box sx={{ display: 'flex', width: { xs: "100%", md: "70%", lg: "75%" } }}>
                        <ItemCollectionDisplay
                            displayParams={displayParams as DisplayParams}
                            onDisplayChange={setDisplayParams} />
                    </Box>)
                }
            </Box>
        </>
    );
}